import React, { useContext } from 'react'
import { AnalyticsContext } from '#src/containers/Analytics'
import { Button } from '@deal/components'
import { Link } from 'react-router-dom'
import styles from './styles.css'

interface CategoryModalContentProps {
  categorySlug: string
  headline: JSX.Element | string
  smallHeadline: JSX.Element | string
  buttonText: string
  variation: string
  pathUrl: string
}

const CategoryModalContent: React.SFC<CategoryModalContentProps> = ({
  categorySlug,
  headline,
  smallHeadline,
  buttonText,
  variation,
  pathUrl
}) => {
  const analytics = useContext(AnalyticsContext)

  return (
    <div className={styles.wrapper}>
      <div className={styles.largeHeader}>{headline}</div>
      <div className={styles.smallHeader}>{smallHeadline}</div>
      <div className={styles.action}>
        <Link
          to={pathUrl}
          onClick={() => {
            analytics?.events.engagementChannelSubmitted({
              engagement_channel: 'category-modal-dual-headline',
              category: categorySlug,
              variation
            })
          }}
        >
          <Button className={styles.button}>{buttonText}</Button>
        </Link>
      </div>
    </div>
  )
}

export default CategoryModalContent
